define.alias("shared/components/shared/media-items/media-item", "calendar/components/shared/media-items/media-item");